var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagTokelau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4307C24.8366 32.4307 32 25.2672 32 16.4307C32 7.59411 24.8366 0.430664 16 0.430664C7.16344 0.430664 0 7.59411 0 16.4307C0 25.2672 7.16344 32.4307 16 32.4307Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7391 8.08285C25.5956 8.77254 25.5304 9.5071 25.5304 10.2394C25.5304 14.4602 28.0466 18.1134 31.6526 19.758C31.8796 18.6845 32 17.5717 32 16.4307C32 7.59416 24.8365 0.430664 16 0.430664C7.1635 0.430664 0 7.59416 0 16.4307C0 25.2672 7.1635 32.4307 16 32.4307C21.4801 32.4307 26.3161 29.6749 29.1998 25.4742H9.0435V23.3872H30.4124C30.6311 22.935 30.8286 22.4707 31.0049 21.9959H9.0435L25.7391 8.08285Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7548 8.77832L12.1002 9.8412H13.2177L12.3136 10.4981L12.659 11.5609L11.7548 10.9041L10.8507 11.5609L11.1961 10.4981L10.2919 9.8412H11.4094L11.7548 8.77832Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21516 16.4307L7.64691 17.7594H9.04378L7.9136 18.5803L8.34535 19.9089L7.21516 19.0878L6.08503 19.9089L6.51672 18.5803L5.3866 17.7594H6.78347L7.21516 16.4307Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21516 5.30029L7.64691 6.62898H9.04378L7.9136 7.44992L8.34535 8.77854L7.21516 7.95742L6.08503 8.77854L6.51672 7.44992L5.3866 6.62898H6.78347L7.21516 5.30029Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73664 11.561L4.16839 12.8897H5.56521L4.43508 13.7107L4.86683 15.0393L3.73664 14.2182L2.60652 15.0393L3.03821 13.7107L1.90808 12.8897H3.30489L3.73664 11.561Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTokelau);
export default __webpack_public_path__ + "static/media/flag_tokelau.0306d678f8aebed9e9042ef1feebbb6c.svg";
export { ForwardRef as ReactComponent };